import React, { Component } from "react";

import OrderedRater from "./OrderedRater.js";
import '../../Styles/customerForm.css';

class OrderedRaterList extends Component {
	constructor() {
		super();
	}
	
	render() {
		//console.log("OrderedSupplierList RENDER");
		//console.log(this.props);
		let raters=[];
		let i=0;
		if(typeof this.props.raters !== "undefined"){
			this.props.raters.forEach((rater) => {
				raters.push(
					<OrderedRater
						id={rater.id}
						username={rater.user.username}
						index={i}
						handleMorePriority={this.props.handleMorePriority}
					/>
				)
				i++;
			});
		}
		return (
			<span className='orderedsupplierlist'>
				{raters}
			</span>
		);
	}
}

export default OrderedRaterList;